import"../../../node_modules/.pnpm/@lit_reactive-element@2.1.0/node_modules/@lit/reactive-element/reactive-element.js";import{html as i}from"../../../node_modules/.pnpm/lit-html@3.3.0/node_modules/lit-html/lit-html.js";import"../../../node_modules/.pnpm/lit-element@4.2.0/node_modules/lit-element/lit-element.js";import{icon as t}from"../../icon-registry.js";const p=t("chile",i`
        <svg
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            static>
            <path
                d="M0 4.5H24V20.5H0V4.5Z"
                fill="#D80027" />
            <path
                d="M9.16943 4.5H23.9998V12.5H9.16943V4.5Z"
                fill="white" />
            <path
                d="M0 4.5H9.16959V12.5H0V4.5Z"
                fill="#0037A1" />
            <path
                d="M4.58497 5.64648L5.2914 7.82192H7.57912L5.72649 9.16461L6.4376 11.3401L4.58497 9.99736L2.73234 11.3401L3.44345 9.16461L1.59082 7.82192H3.87854L4.58497 5.64648Z"
                fill="white" />
        </svg>
    `),l=i`
    <svg
        width="24"
        height="25"
        viewBox="0 0 24 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        static>
        <mask
            id="mask0_4915_40015"
            style="mask-type:alpha"
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="24"
            height="25">
            <circle
                cx="12"
                cy="12.5"
                r="12"
                fill="#D9D9D9" />
        </mask>
        <g mask="url(#mask0_4915_40015)">
            <g clip-path="url(#clip0_4915_40015)">
                <path
                    d="M-2 0.5H34V24.5H-2V0.5Z"
                    fill="#D80027" />
                <path
                    d="M11.7544 0.5H34V12.5H11.7544V0.5Z"
                    fill="white" />
                <path
                    d="M-2 0.5H11.7544V12.5H-2V0.5Z"
                    fill="#0037A1" />
                <path
                    d="M4.87697 2.21973L5.93662 5.48288H9.3682L6.58925 7.49692L7.65592 10.7601L4.87697 8.74604L2.09802 10.7601L3.16469 7.49692L0.385742 5.48288H3.81732L4.87697 2.21973Z"
                    fill="white" />
            </g>
        </g>
        <defs>
            <clipPath id="clip0_4915_40015">
                <rect
                    width="36"
                    height="24"
                    fill="white"
                    transform="translate(-2 0.5)" />
            </clipPath>
        </defs>
    </svg>
`,d=t("chile_rounded",l),o=t("CLP",l);export{o as CLP,p as Chile,d as ChileRounded};
